import type { Announcements } from '@dnd-kit/core';

/**
 * Custom @dnd-kit announcements that match react-beautiful-dnd's screen-reader
 * copy. Used with Option B of CNSG-1472 so `userDragAndDrop` can keep waiting on
 * the same strings after the library migration.
 *
 * Wire into each migrated DndContext:
 *   <DndContext accessibility={{ announcements: dndKitAnnouncements }} ... />
 */
export const dndKitAnnouncements: Announcements = {
  onDragStart: () => 'You have lifted an item.',
  onDragOver: () => 'You have moved the item.',
  onDragEnd: () => 'You have dropped the item.',
  onDragCancel: () => 'You have dropped the item.',
};
